const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

// For data inserted into text rendered with v-html, such as an insurer title
// in a translation: the i18n setup doesn't escape parameters, so markup in the
// data would otherwise run as HTML.
export const escapeHtml = (text: string | null | undefined) =>
  (text ?? '').replace(/[&<>"']/g, (char) => HTML_ESCAPES[char])
